var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconKingBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.83 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.79 7V6c.58 0 1.04-.45 1.04-1V1c0-.55-.47-1-1.04-1H1.04C.47 0 0 .45 0 1v4c0 .55.47 1 1.04 1v9C.47 15 0 15.45 0 16v2c0 .55.47 1 1.04 1h1.04c0 .55.47 1 1.04 1s1.04-.45 1.04-1h12.5c0 .55.47 1 1.04 1 .58 0 1.04-.45 1.04-1h1.04c.58 0 1.04-.45 1.04-1v-2c0-.55-.47-1-1.04-1V7zm0 10.75c0 .14-.12.25-.26.25H1.3c-.14 0-.26-.11-.26-.25v-1.5c0-.14.12-.25.26-.25h18.23c.14 0 .26.11.26.25v1.5zM9.38 8h9.38v7H2.08V8h7.3zM3.13 5.5v-2c0-.28.23-.5.52-.5h5.21c.29 0 .52.22.52.5v2c0 .28-.24.5-.53.5h-5.2c-.29 0-.52-.22-.52-.5zm8.33 0v-2c0-.28.23-.5.52-.5h5.21c.29 0 .52.22.52.5v2c0 .28-.23.5-.52.5h-5.21c-.29 0-.52-.22-.52-.5zm7.81-.5h-.52V3c0-.55-.47-1-1.04-1H3.13c-.58 0-1.05.45-1.05 1v2h-.52c-.29 0-.52-.22-.52-.5v-3c0-.28.17-.5.38-.5h18c.21 0 .38.22.38.5v3c-.01.28-.24.5-.53.5z",
    fill: "#1ab2c5"
  })));
}

export default SvgIconKingBed;